import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class Home extends Default {
  constructor() {
    super();
  }
}

ControllerPage._addPage('home', Home);
